var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_4085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 14.9289C17.9819 13.8398 16.6855 13.0335 15.2711 12.5454C16.786 11.502 17.7812 9.75578 17.7812 7.78125C17.7812 4.59348 15.1878 2 12 2C8.81223 2 6.21875 4.59348 6.21875 7.78125C6.21875 9.75578 7.21402 11.502 8.72898 12.5454C7.31453 13.0335 6.01813 13.8398 4.92895 14.9289C3.0402 16.8177 2 19.3289 2 22H3.5625C3.5625 17.3475 7.34754 13.5625 12 13.5625C16.6525 13.5625 20.4375 17.3475 20.4375 22H22C22 19.3289 20.9598 16.8177 19.0711 14.9289ZM12 12C9.67379 12 7.78125 10.1075 7.78125 7.78125C7.78125 5.455 9.67379 3.5625 12 3.5625C14.3262 3.5625 16.2188 5.455 16.2188 7.78125C16.2188 10.1075 14.3262 12 12 12Z",
    fill: "#494949",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_4085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconGrey);
export default __webpack_public_path__ + "static/media/profile_icon_grey.bba9fe94a3b2ae5dfaa1f621620a45e4.svg";
export { ForwardRef as ReactComponent };